import React from 'react';

import ConfirmationModalPresentation from './ConfirmationModalPresentation';

export default class ConfirmationModal extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { handleClickOutPortal, handleConfirm, message } = this.props;
        return (
            <ConfirmationModalPresentation
                message={message}
                handleClickOutPortal={handleClickOutPortal}
                handleConfirm={handleConfirm}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/modals-components/ConfirmationModal/index.js